module.exports = __webpack_public_path__ + "static/img/item8.c19af73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/item8.png
// module id = CWhV
// module chunks = 63